import PageNav from "@/components/PageNav/PageNav.vue";
import Footer from "@/components/Footer/footer.vue";
import idAuth from "@/views/Home/personal/idAuth/idAuth.vue";
// API 管理入口已暂时下线。
// import apiManagement from "./apiManagement/apiManagement.vue";
// import recommendInvite from "./recommendInvite/recommendInvite.vue";
import safetyRecord from "./safetyRecord/safetyRecord.vue";
import bindEmail from "./bindEmail/bindEmail.vue";
import changePhone from "./changePhone/changePhone.vue";
import bindGoogle from "./bindGoogle/bindGoogle.vue";
import changePassword from "./changePassword/changePassword.vue";
import userSettings from "./userSettings/userSettings.vue";
import Model from "@/components/model/modelContent.vue";
import {mapGetters, mapState} from "vuex";
import userApi from "@/common/api/user";
import util from "@/common/util";

export default {
    components: {
        Footer,
        PageNav,
        idAuth,
        // apiManagement,
        // recommendInvite,
        safetyRecord,
        userSettings,
        Model,
        bindEmail,
        changePhone,
        bindGoogle,
        changePassword,
    },
    data() {
        return {
            menuList: [
                {
                    id: 1,
                    text: "personal.overview",
                },
                {
                    id: 2,
                    text: "personal.identity_verification",
                },
                // API 管理入口已暂时下线。
                // {
                //     id: 3,
                //     text: "personal.api",
                // },
                // 邀请返佣入口已暂时下线：
                // {
                //     id: 4,
                //     text: "personal.invitation_rewards",
                // },
                {
                    id: 5,
                    text: "personal.preferences",
                },
            ],
            activeKey: 1,
            showImg: false,
            //控制主页面
            userManagement: true,
            // 控制子页面
            safetyRecord: false,
            bindEmail: false,
            changePhone: false,
            bindGoogle: false,
            changePassword: false,
            setting: [], // 初始化为空数组，在mounted中设置
            visible: false,
            eyeShow: false,
            // 资产相关数据
            userBalance: '0.00',
            isLoadingBalance: false,
            // 认证状态
            authStatus: null, // null=未认证, 0=审核中, 1=已通过, 2=已拒绝
            authInfo: null // 认证信息
        };
    },
    computed: {
        ...mapGetters(['userId', 'userNickname', 'userAccount', 'userTheme']),
        ...mapState(['userinfo'])
    },
    watch: {
        // 监听语言变化
        '$i18n.locale'() {
            this.initializeSettings();
        },
        // 监听路由查询参数变化
        '$route.query': {
            handler(newQuery) {
                if (newQuery && newQuery.activeKey) {
                    const activeKey = parseInt(newQuery.activeKey);
                    if (activeKey >= 1 && activeKey <= 5 && this.activeKey !== activeKey) {
                        this.activeKey = activeKey;
                        console.log('✅ 路由查询参数变化，设置 activeKey:', activeKey);
                    }
                }
            },
            immediate: true,
            deep: true
        }
    },
    beforeUnmount() {
        // 清理定时器
        if (this.balanceTimer) {
            clearInterval(this.balanceTimer);
        }
    },
    mounted() {
        console.log('🚀 用户管理页面初始化...');
        console.log('用户信息:', this.userinfo);
        console.log('路由参数:', this.$route.params);
        console.log('路由查询参数:', this.$route.query);
        
        // 检查路由查询参数中的 activeKey，如果有则设置
        if (this.$route.query.activeKey) {
            const activeKey = parseInt(this.$route.query.activeKey);
            if (activeKey >= 1 && activeKey <= 5) {
                this.activeKey = activeKey;
                console.log('✅ 从路由参数设置 activeKey:', activeKey);
            }
        }
        
        // 初始化设置数据
        this.initializeSettings();
        
        // 获取用户资产数据
        this.loadUserBalance();
        
        // 获取认证状态
        this.getAuthStatus();
        
        // 延迟检查绑定状态，确保用户信息已加载
        setTimeout(() => {
            console.log('🔄 重新检查绑定状态...');
            this.initializeSettings();
        }, 1000);
        // 定时刷新资产数据（每30秒）
        this.balanceTimer = setInterval(() => {
            this.loadUserBalance();
        }, 30000);
    },
    methods: {
        // 初始化设置数据
        initializeSettings() {
            if (!this.$t) return; // 如果$t还没有准备好，直接返回
            
            // 如果setting数组已存在，只更新文本，保持原有的绑定状态
            if (this.setting && this.setting.length > 0) {
                this.setting.forEach((item, index) => {
                    const configs = [
                        {
                            name: this.$t('personal.email_verification'),
                            des: this.$t('personal.email_verification_desc'),
                            btn: this.$t('personal.bind'),
                        },
                        // 手机验证、谷歌验证入口暂时下线。
                        {
                            name: this.$t('personal.login_password'),
                            des: this.$t('personal.login_password_desc'),
                            btn: this.$t('personal.edit'),
                        }
                    ];
                    
                    if (configs[index]) {
                        item.name = configs[index].name;
                        item.des = configs[index].des;
                        item.btn = configs[index].btn;
                        
                        // 重新检查绑定状态
                        if (index === 0) { // 邮箱验证
                            const emailBound = this.checkEmailBinding();
                            item.ifBind = emailBound;
                            console.log('📧 邮箱绑定状态:', emailBound);
                        }
                        
                        // 更新状态文字和颜色
                        if (item.ifBind) {
                            item.status.name = this.$t('personal.bound');
                            item.status.color = "#26c99b";
                            console.log('✅ 已绑定状态:', item.name);
                        } else {
                            item.status.name = this.$t('personal.unbound');
                            item.status.color = "#ff9e2d";
                            console.log('❌ 未绑定状态:', item.name);
                        }
                    }
                });
                return;
            }
            
            // 首次初始化
            const emailBound = this.checkEmailBinding();
            
            this.setting = [
                {
                    name: this.$t('personal.email_verification'),
                    des: this.$t('personal.email_verification_desc'),
                    status: {
                        name: emailBound ? this.$t('personal.bound') : this.$t('personal.unbound'),
                        color: emailBound ? "#26c99b" : "#ff9e2d",
                    },
                    btn: this.$t('personal.bind'),
                    type: "primary",
                    ifBind: emailBound,
                    ifShow: false,
                    component: "bindEmail",
                },
                // 手机验证、谷歌验证入口暂时下线。
                {
                    name: this.$t('personal.login_password'),
                    des: this.$t('personal.login_password_desc'),
                    status: {
                        name: this.$t('personal.bound'),
                        color: "#52c41a",
                    },
                    btn: this.$t('personal.edit'),
                    type: "primary",
                    ifBind: true,
                    ifShow: false,
                    component: "changePassword",
                },
            ];
        },
        // 获取用户资产数据
        async loadUserBalance() {
            try {
                this.isLoadingBalance = true;
                const res = await userApi.getBalance();
                if (res && res.code === 200) {
                    // 使用资产页面的计算方法
                    let total = 0;
                    res.data.balance.map((item) => {
                        if (item.symbol === 'USDT') {
                            total += parseFloat(item.balance) + parseFloat(item.contract_balance) +
                                parseFloat(item.finance_balance) + parseFloat(item.future_balance) +
                                parseFloat(item.trade_balance);
                        } else {
                            let new_price = parseFloat(item.new_price != null ? item.new_price : 0);
                            total += (parseFloat(item.balance) + parseFloat(item.contract_balance) +
                                parseFloat(item.finance_balance) + parseFloat(item.future_balance) +
                                parseFloat(item.trade_balance)) * new_price;
                        }
                    });
                    
                    this.userBalance = total.toFixed(2);
                } else {
                    console.error(this.$t('personal.failed_to_get_assets') + ':', res?.message || this.$t('personal.unknown_error'));
                    this.userBalance = '0.00';
                }
            } catch (error) {
                console.error(this.$t('personal.assets_data_exception') + ':', error);
                this.userBalance = '0.00';
            } finally {
                this.isLoadingBalance = false;
            }
        },
        // 刷新资产数据
        async refreshBalance() {
            await this.loadUserBalance();
        },
        // 跳转到充值页面
        goToRecharge() {
            console.log('跳转到充值页面');
            this.$router.push('/topup');
        },
        toSafety() {
            this.userManagement = false;
            this.safetyRecord = true;
        },
        numSelect(e) {
            this.decimal = e;
        },
        tabActive(e) {
            console.log('📌 切换标签页:', e);
            this.safetyRecord = false;
            this.activeKey = e;
            // 更新路由查询参数，保持 URL 和状态同步
            if (this.$route.path === '/HomeView/personal') {
                this.$router.replace({
                    path: this.$route.path,
                    query: { ...this.$route.query, activeKey: e }
                }).catch(err => {
                    // 忽略导航重复的错误
                    if (err.name !== 'NavigationDuplicated') {
                        console.error('路由更新失败:', err);
                    }
                });
            }
        },
        goBack() {
            this.safetyRecord = false;
            this.bindEmail = false;
            this.changePhone = false;
            this.bindGoogle = false;
            this.changePassword = false;
            this.userManagement = true;
        },
        handleClick() {
            this.visible = true;
        },
        handleOkA() {
            console.log(this.$t('personal.confirm'))
            this.visible = false;
        },
        handleCancel() {
            this.visible = false;
        },
        ClickToBind(e) {
            switch (e.component) {
                case 'bindEmail':
                    if (e.ifShow) {
                        console.log(e, this.$t('personal.already_bound_modify'))
                    } else {
                        this.bindEmail = true
                        this.userManagement = false
                    }
                    break;
                case 'changePhone':
                    if (e.ifShow) {
                        console.log(e, this.$t('personal.already_bound_modify'))
                    } else {
                        this.changePhone = true
                        this.userManagement = false
                    }
                    break;
                case 'bindGoogle':
                    if (e.ifShow) {
                        console.log(e, this.$t('personal.already_bound_modify'))
                    } else {
                        this.bindGoogle = true
                        this.userManagement = false
                    }
                    break;
                case 'changePassword':
                    if (e.ifShow) {
                        console.log(e, this.$t('personal.already_bound_modify'))
                    } else {
                        this.changePassword = true
                        this.userManagement = false
                    }
                    break;
                default:
                    break;
            }
        },
        
        // 获取认证状态
        async getAuthStatus() {
            try {
                console.log('🔍 获取认证状态...');
                const response = await userApi.baseAuthInfo();
                
                if (response && response.code === 200 && response.data) {
                    this.authInfo = response.data;
                    this.authStatus = response.data.status || null;
                    
                    console.log('✅ 认证状态获取成功:', {
                        status: this.authStatus,
                        info: this.authInfo
                    });
                } else {
                    console.log('ℹ️ 未找到认证信息，可能是首次认证');
                    this.authStatus = null;
                    this.authInfo = null;
                }
            } catch (error) {
                console.error('❌ 获取认证状态失败:', error);
                this.authStatus = null;
                this.authInfo = null;
            }
        },
        
        // 获取认证状态显示文本
        getVerificationStatus() {
            if (this.authStatus === null || this.authStatus === undefined) {
                return this.$t('personal.not_verified');
            } else if (this.authStatus === 0 || this.authStatus === '0') {
                return this.$t('personal.verification_pending');
            } else if (this.authStatus === 1 || this.authStatus === '1') {
                return this.$t('personal.verified');
            } else if (this.authStatus === 2 || this.authStatus === '2') {
                return this.$t('personal.verification_rejected');
            } else {
                return this.$t('personal.not_verified');
            }
        },
        // 检查邮箱绑定状态
        checkEmailBinding() {
            console.log('🔍 检查邮箱绑定状态...');
            console.log('用户信息:', this.userinfo);
            
            // 检查用户信息中是否有邮箱
            if (this.userinfo && this.userinfo.email) {
                console.log('✅ 用户已绑定邮箱:', this.userinfo.email);
                return true;
            }
            
            // 检查用户账号（可能是邮箱格式）
            if (this.userinfo && this.userinfo.account) {
                const account = this.userinfo.account;
                // 检查是否是邮箱格式
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (emailRegex.test(account)) {
                    console.log('✅ 用户账号是邮箱格式:', account);
                    return true;
                }
            }
            
            // 检查用户登录时使用的邮箱（从缓存中获取）
            const cachedEmail = util.getCache('login_email');
            if (cachedEmail) {
                console.log('✅ 从缓存中找到登录邮箱:', cachedEmail);
                return true;
            }
            
            // 检查用户是否有登录凭证（通常邮箱登录的用户会有email字段）
            if (this.userinfo && typeof this.userinfo === 'object') {
                // 遍历用户信息的所有字段，查找邮箱格式的数据
                for (const key in this.userinfo) {
                    const value = this.userinfo[key];
                    if (typeof value === 'string' && value.includes('@')) {
                        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                        if (emailRegex.test(value)) {
                            console.log('✅ 在用户信息中找到邮箱字段:', key, value);
                            return true;
                        }
                    }
                }
            }
            
            console.log('❌ 用户未绑定邮箱');
            return false;
        },
        // 检查手机绑定状态
        checkPhoneBinding() {
            if (this.userinfo && this.userinfo.phone) {
                console.log('✅ 用户已绑定手机:', this.userinfo.phone);
                return true;
            }
            console.log('❌ 用户未绑定手机');
            return false;
        },
        // 检查谷歌验证绑定状态
        checkGoogleBinding() {
            if (this.userinfo && this.userinfo.google2fa) {
                console.log('✅ 用户已绑定谷歌验证');
                return true;
            }
            console.log('❌ 用户未绑定谷歌验证');
            return false;
        }
    },
};
